import { render, staticRenderFns } from "./NotificationContact.vue?vue&type=template&id=2043a9ae"
import script from "./NotificationContact.vue?vue&type=script&lang=ts"
export * from "./NotificationContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports